/**
 * 🏗️ FSD Shared Layer - Activity Constants
 * 
 * ActivityPage에서 사용되는 색상 매핑 및 설정들
 */ /**
 * 학습 영역별 색상 매핑
 */ export var AREA_COLORS = {
    // 전문 영역
    '알고리즘': {
        bg: 'bg-blue-500',
        text: 'text-blue-700'
    },
    '프론트엔드': {
        bg: 'bg-purple-500',
        text: 'text-purple-700'
    },
    '백엔드': {
        bg: 'bg-green-500',
        text: 'text-green-700'
    },
    '데이터베이스': {
        bg: 'bg-yellow-500',
        text: 'text-yellow-700'
    },
    '컴퓨터 과학': {
        bg: 'bg-pink-500',
        text: 'text-pink-700'
    },
    '소프트웨어 설계': {
        bg: 'bg-cyan-500',
        text: 'text-cyan-700'
    },
    // 코딩 기본기
    '자료구조': {
        bg: 'bg-indigo-500',
        text: 'text-indigo-700'
    },
    '코딩 스타일': {
        bg: 'bg-amber-500',
        text: 'text-amber-700'
    },
    '디버깅': {
        bg: 'bg-red-500',
        text: 'text-red-700'
    },
    '버전 관리': {
        bg: 'bg-emerald-500',
        text: 'text-emerald-700'
    },
    '테스트 작성': {
        bg: 'bg-fuchsia-500',
        text: 'text-fuchsia-700'
    },
    '성능 최적화': {
        bg: 'bg-orange-500',
        text: 'text-orange-700'
    },
    '보안': {
        bg: 'bg-rose-500',
        text: 'text-rose-700'
    },
    '코드 리팩토링': {
        bg: 'bg-teal-500',
        text: 'text-teal-700'
    }
};
/**
 * 기본 필터 설정
 */ export var DEFAULT_FILTERS = {
    type: '전체',
    period: '이번 주',
    completed: '전체'
};
